import {
  getStatus,
  getIconType,
  getImportance,
  getSolvability,
} from '../../constants/seoMappings';

/**
 * Generates message for robots.txt section
 * @param {Object} data - The robots.txt data object
 * @returns {string|null} - Message for empty state or null if data exists
 */
const generateMessage = (data) => {
  if (!data?.url) {
    return 'No robots.txt file was found.';
  }
  return null;
};

/**
 * Transforms the robots_txt criteria from WooRank API response
 * @param {Object} robotsTxtCriteria - The robots_txt criteria object from the API
 * @returns {Object} - Transformed robots.txt data for React components
 */
export const transformRobotsTxt = (robotsTxtCriteria) => {
  // Handle missing criteria - use 'neutral' status (maps to 'info' icon)
  if (!robotsTxtCriteria) {
    return {
      status: getStatus('neutral'),
      iconType: getIconType('neutral'),
      importance: { level: 0, text: '' },
      solvability: { level: 0, text: '' },
      isEmpty: true,
      message: 'No robots.txt file was found.',
      data: null,
    };
  }

  const data = robotsTxtCriteria?.data || {};
  const wooRankStatus = robotsTxtCriteria?.status || 'neutral';
  const importance = robotsTxtCriteria?.importance || 0;
  const solvability = robotsTxtCriteria?.solvability || 0;

  const isEmpty = !data?.url;

  return {
    status: getStatus(wooRankStatus),
    iconType: getIconType(wooRankStatus),
    importance: getImportance(importance),
    solvability: getSolvability(solvability),
    isEmpty,
    message: generateMessage(data),
    data: isEmpty ? null : {
      url: data?.url || '',
    },
  };
};

export default transformRobotsTxt;

